module.exports = __webpack_public_path__ + "static/media/achievement-10.a1362135.png";